import React, { useEffect }  from 'react';
import { Document, Page, Text, View, StyleSheet,Image, Font } from '@react-pdf/renderer';
import { useStore } from '../../../../app/stores/store';
import agent from '../../../../app/api/agent';
import { getImageSrc } from '../../../../utils/ImageHelper';

interface DCPEncryptedOpenReportProps {
  name: any;
  localElement: any;
  metadata: any[];
  subtaskId:any;
  isDualPDF:boolean;
}
Font.register({
  family: 'Roboto',
  fonts: [
    {
      src: `${process.env.PUBLIC_URL}/assets/fonts/Roboto-Regular.ttf`,
      fontWeight: 'normal',
    },
    {
      src: `${process.env.PUBLIC_URL}/assets/fonts/Roboto-SemiBold.ttf`,
      fontWeight: 'bold',
    },
  ],
});
const styles = StyleSheet.create({
  page: {
    padding: 10,
    marginTop: 20,
    fontFamily: 'Roboto',
  },
  header: {
    backgroundColor: '#f2cb05',
    padding: 5,
    textAlign: 'center',
    fontWeight: 'bold',
    fontSize: 10,
    border: '1pt solid black',
  },
  subHeader: {
    backgroundColor: '#d9d6d6',
    padding: 4,
    textAlign: 'center',
    fontWeight: 'bold',
    fontSize: 9,
    borderLeft: '1pt solid black',
    borderRight: '1pt solid black',
    borderBottom: '1pt solid black',
  },
  seperator:{
    backgroundColor: '#a6a6a6'
  },
  row: {
    flexDirection: 'row',
    borderLeft: '1pt solid black',
    borderRight: '1pt solid black',
    borderBottom: '1pt solid black',
  },
  cellHeader: {
    flex: 1,
    backgroundColor: '#D0CECE',
    padding: 4,
    fontWeight: 'bold',
    borderRight: '1pt solid black',
    fontSize: "6.5px",
  },
  cellLabel: {
    flex: 1,
    padding: 4,
    fontWeight: 'bold',
    borderRight: '1pt solid black',
     fontSize: "6.5px",
  },
cell: {
  flex: 1,
  padding: 4,
  borderRight: '1pt solid black',
  whiteSpace: 'pre-wrap', 
   fontSize: "6.5px",
},

cell1: {
  flex: 2,
  padding: 4,
  borderRight: '1pt solid black',
  whiteSpace: 'pre-wrap', 
   fontSize: "6.5px",
},

cell2: {
  flex: 3,
  padding: 4,
  borderRight: '1pt solid black',
  whiteSpace: 'pre-wrap', 
   fontSize: "6.5px",
},


  noRightBorder: {
    borderRight: 0,
  },
    tableTitleRow: {
    flexDirection: 'row',
    backgroundColor: '#bfbfbf',
    fontWeight: 'bold',
    border: '1pt solid black',
  },
  plainCellLabel: {
  flex: 1,
  padding: 4,
  fontWeight: 'bold',
  borderRight: '1pt solid black',
  fontSize:'6.5px'
},
checkbox: {
    width: 10,
    height: 10,
    marginRight: 4,
  },
  checkboxRow: {
    flexDirection: "row",
    alignItems: "center",
  },

});

export const balaSign = (marginTops:string,deliver:boolean,name?:string) => {
  return (<View style={{flexDirection: 'row', marginTop: `${marginTops}`, marginBottom: '5px' }} >
<View style={{flex: 2.5}}>
  <Text>
  <Text></Text>
  <Text></Text>
</Text>
</View>
<View style={{flex: 1.5}}>
  <Text><Image src={getImageSrc('bala')} style={{
        width: deliver ? 60 : 90,
        height: deliver ? 60 : 90,
        paddingRight: 100,
        ...(name === 'dcp' && { paddingBottom: '200px' , height : 100})
      }
      }/></Text>
  </View>
</View>)
}
const DCPEncryptedOpenReport: React.FC<DCPEncryptedOpenReportProps> = ({
  name,
  localElement,
  metadata,
  subtaskId,
  isDualPDF
}) => {
  const { masteringStore, activityStore } = useStore();
useEffect(() => {
  const fetchData = async () => {
    try {
      const response = await agent.NFAI.Ffv1QcReport1(activityStore.selectedActivity?.id,subtaskId);
      masteringStore.DcpEncrypedOpenReportInfo = response.data;
    } catch (err) {
      console.error(err);
    }
  };
  fetchData();
  //eslint-disable-next-line
}, []);

// Replace your softWrap function with this:
const forceWrap = (value: any, maxChunkLength = 45): string => {
  const text = value != null ? String(value) : "";
  // Split the string every maxChunkLength characters, join with newline
  return text.match(new RegExp(`.{1,${maxChunkLength}}`, 'g'))?.join('\n') || "";
};

  return  (
  
  <Document>
    <Page size="A4" style={styles.page}>
      {/* Header */}
      <Text style={styles.header}>
        DCI - DCP MASTERING - QUALITY CHECK REPORT
      </Text>
      <Text style={styles.subHeader}>NFHM Restoration Project</Text>
      <Text style={styles.subHeader}>
        PICTURE VENDOR NAME: Prasad Corporation Pvt Ltd, Chennai
      </Text>

      {/* 4-column rows */}


      <View style={styles.row}>
        <Text style={styles.cellHeader}>{masteringStore.DcpEncrypedOpenReportInfo[1]?.elementName} :</Text>
        <Text style={styles.cell1}>{masteringStore.DcpEncrypedOpenReportInfo[1]?.elementValue}</Text>
        <Text style={styles.cellLabel}>{masteringStore.DcpEncrypedOpenReportInfo[11]?.elementName}:</Text>
        <Text style={[styles.cell, styles.noRightBorder]}>{masteringStore.DcpEncrypedOpenReportInfo[11]?.elementValue}</Text>
      </View>

      <View style={styles.row}>
        <Text style={styles.cellHeader}>{masteringStore.DcpEncrypedOpenReportInfo[2]?.elementName}</Text>
        <Text style={styles.cell1}>{masteringStore.DcpEncrypedOpenReportInfo[2]?.elementValue}</Text>
        <Text style={styles.cellLabel}>{masteringStore.DcpEncrypedOpenReportInfo[12]?.elementName}:</Text>
        <Text style={[styles.cell, styles.noRightBorder]}>{masteringStore.DcpEncrypedOpenReportInfo[12]?.elementValue}</Text>
      </View>

      <View style={styles.row}>
        <Text style={styles.cellHeader}>{masteringStore.DcpEncrypedOpenReportInfo[0]?.elementName}</Text>
        <Text style={styles.cell1}>{masteringStore.DcpEncrypedOpenReportInfo[0]?.elementValue}</Text>
        <Text style={styles.cellLabel}>{masteringStore.DcpEncrypedOpenReportInfo[13]?.elementName}</Text>
        <Text style={[styles.cell, styles.noRightBorder]}>{masteringStore.DcpEncrypedOpenReportInfo[13]?.elementValue}</Text>
      </View>

      {/* RESOLUTION row - 4 columns */}
     <View style={styles.row}>
  {/* Left label cell */}
  <Text style={styles.cellHeader}>
    {masteringStore.DcpEncrypedOpenReportInfo[3]?.elementName}:
  </Text>

  {/* Checkbox cell for 4K & 2K */}
  <View style={[styles.cell1, styles.checkboxRow]}>
    <Image
      src={
        masteringStore.DcpEncrypedOpenReportInfo[3]?.elementValue?.includes('4K')
          ? '/assets/NFAI_Restoration_Checkbox_Checked.png'
          : '/assets/NFAI_Restoration_Checkbox_Unchecked.png'
      }
      style={styles.checkbox}
    />
    <Text>4K</Text>

    <Image
      src={
        masteringStore.DcpEncrypedOpenReportInfo[3]?.elementValue?.includes('2K')
          ? '/assets/NFAI_Restoration_Checkbox_Checked.png'
          : '/assets/NFAI_Restoration_Checkbox_Unchecked.png'
      }
      style={[styles.checkbox, { marginLeft: 10 }]}
    />
    <Text>2K</Text>
  </View>

  {/* Empty right cell to complete 4-column layout */}

      <Text style={[styles.cell,styles.noRightBorder]}>
  </Text>
 <Text style={[styles.cell,styles.noRightBorder]}>
  </Text>
</View>


      {/* SOURCE DPX row - 4 columns */}
      <View style={styles.row}>
  {/* Label cell */}
  <Text style={styles.cellHeader}>
    {masteringStore.DcpEncrypedOpenReportInfo[4]?.elementName}:
  </Text>

  {/* Checkbox list cell */}
  <View style={[styles.cell1, styles.checkboxRow, styles.noRightBorder]}>
    {/* B&W */}
    <Image
      src={
          masteringStore.DcpEncrypedOpenReportInfo[4]?.elementValue?.toLowerCase()?.includes('b & w')
          ? '/assets/NFAI_Restoration_Checkbox_Checked.png'
          : '/assets/NFAI_Restoration_Checkbox_Unchecked.png'
      }
      style={styles.checkbox}
    />
    <Text>B&W</Text>

    {/* COLOR */}
    <Image
      src={
        masteringStore.DcpEncrypedOpenReportInfo[4]?.elementValue?.toLowerCase()?.includes('colour')
          ? '/assets/NFAI_Restoration_Checkbox_Checked.png'
          : '/assets/NFAI_Restoration_Checkbox_Unchecked.png'
      }
      style={[styles.checkbox, { marginLeft: 10 }]}
    />
    <Text>COLOR</Text>

    {/* LOG */}
    <Image
      src={
          '/assets/NFAI_Restoration_Checkbox_Unchecked.png'
      }
      style={[styles.checkbox, { marginLeft: 10 }]}
    />
    <Text>LOG</Text>

    {/* LINEAR */}
    <Image
      src={
        '/assets/NFAI_Restoration_Checkbox_Checked.png'
      }
      style={[styles.checkbox, { marginLeft: 10 }]}
    />
    <Text>LINEAR</Text>
  </View>
      <Text style={[styles.cell,styles.noRightBorder]}>
  </Text>
 <Text style={[styles.cell,styles.noRightBorder]}>
  </Text>
</View>


      {/* BIT DEPTH row - 4 columns */}
      <View style={styles.row}>
  {/* Left Label Cell */}
  <Text style={styles.cellHeader}>
    {masteringStore.DcpEncrypedOpenReportInfo[5]?.elementName}
  </Text>

  {/* Right Checkbox Cell */}
  <View style={[styles.cell1, styles.noRightBorder, styles.checkboxRow]}>
    <Image
      src={
        masteringStore.DcpEncrypedOpenReportInfo[5]?.elementValue?.includes('10')
          ? '/assets/NFAI_Restoration_Checkbox_Checked.png'
          : '/assets/NFAI_Restoration_Checkbox_Unchecked.png'
      }
      style={styles.checkbox}
    />
    <Text>10 bit</Text>

    <Image
      src={
        masteringStore.DcpEncrypedOpenReportInfo[5]?.elementValue?.includes('16')
          ? '/assets/NFAI_Restoration_Checkbox_Checked.png'
          : '/assets/NFAI_Restoration_Checkbox_Unchecked.png'
      }
      style={[styles.checkbox, { marginLeft: 10 }]}
    />
    <Text>16 bit</Text>
  </View>
  
      <Text style={[styles.cell,styles.noRightBorder]}>
  </Text>
 <Text style={[styles.cell,styles.noRightBorder]}>
  </Text>
</View>


      {/* Remaining rows as 2 columns */}
      <View style={styles.row}>
        <Text style={styles.cellHeader}>{masteringStore.DcpEncrypedOpenReportInfo[6]?.elementName}</Text>
        <Text style={[styles.cell1,styles.noRightBorder]}>{masteringStore.DcpEncrypedOpenReportInfo[6]?.elementValue}</Text>
        
      <Text style={[styles.cell,styles.noRightBorder]}>
  </Text>
 <Text style={[styles.cell,styles.noRightBorder]}>
  </Text>
      </View>

      <View style={styles.row}>
        <Text style={styles.cellHeader}>{masteringStore.DcpEncrypedOpenReportInfo[7]?.elementName}</Text>
        <Text style={[styles.cell1,styles.noRightBorder]}>
         {masteringStore.DcpEncrypedOpenReportInfo[7]?.elementValue}
        </Text>
        
      <Text style={[styles.cell,styles.noRightBorder]}>
  </Text>
 <Text style={[styles.cell,styles.noRightBorder]}>
  </Text>
      </View>

      <View style={styles.row}>
        <Text style={styles.cellHeader}>{masteringStore.DcpEncrypedOpenReportInfo[8]?.elementName}</Text>
        <Text style={[styles.cell1,styles.noRightBorder]}>{masteringStore.DcpEncrypedOpenReportInfo[8]?.elementValue}</Text>
        
      <Text style={[styles.cell,styles.noRightBorder]}>
  </Text>
 <Text style={[styles.cell,styles.noRightBorder]}>
  </Text>
      </View>

      <View style={styles.row}>
        <Text style={styles.cellHeader}>{masteringStore.DcpEncrypedOpenReportInfo[9]?.elementName}</Text>
        <Text style={[styles.cell1,styles.noRightBorder]}>{masteringStore.DcpEncrypedOpenReportInfo[9]?.elementValue}</Text>
        
      <Text style={[styles.cell,styles.noRightBorder]}>
  </Text>
 <Text style={[styles.cell,styles.noRightBorder]}>
  </Text>
      </View>

      <View style={styles.row}>
        <Text style={styles.cellHeader}>{masteringStore.DcpEncrypedOpenReportInfo[10]?.elementName}</Text>
        <Text style={[styles.cell1,styles.noRightBorder]}>{masteringStore.DcpEncrypedOpenReportInfo[10]?.elementValue}</Text>
        
      <Text style={[styles.cell,styles.noRightBorder]}>
  </Text>
 <Text style={[styles.cell,styles.noRightBorder]}>
  </Text>
      </View>
        <Text style={styles.subHeader}></Text>
      {/* Table Header */}
<View style={styles.row}>
  <Text style={[styles.cellHeader, { flex: 1, textAlign:'center'}]}>CHECK PARAMETERS</Text>
  <Text style={[styles.cellHeader, { flex: 2, textAlign:'center'  }]}>TECHNICAL DESCRIPTION</Text>
  <Text style={[styles.cellHeader, { flex: 1, textAlign:'center'  }]}>WARNING / PASS / FAIL</Text>
  <Text style={[styles.cellHeader, styles.noRightBorder, { flex: 1, textAlign:'center'  }]}>REMARKS</Text>
</View>

{/* Table Rows */}
{(() => {
  const dynamicTableIndex = name === "Open QC Report" ? 23 : 22;
  const rawValue = masteringStore.DcpEncrypedOpenReportInfo[dynamicTableIndex]?.elementValue;

  if (!rawValue || !rawValue.startsWith("DynamicTable|")) return null;

  try {
    const tableData = JSON.parse(rawValue.replace("DynamicTable|", ""));

    // Split into two parts
    const firstTen = tableData.slice(0, 23);
    const remaining = tableData.slice(23);
    const tableRender = (row:any,index:number) => {
      return (
        <View style={styles.row} key={row._uuid_ || index}>
            <Text style={[styles.cell, { flex: 1, textAlign: 'center' }]}>
              {forceWrap(row["CHECK PARAMETERS"])}
            </Text>
            <Text style={[styles.cell, { flex: 2, textAlign: 'center' }]}>
              {forceWrap(row["TECHNICAL DISCRIPTION"])}
            </Text>
            <Text style={[styles.cell, { flex: 1, textAlign: 'center' }]}>
              {forceWrap(row["WARNING / PASS / FAIL"])}
            </Text>
            <Text style={[styles.cell, { flex: 1, textAlign: 'center' }, styles.noRightBorder]}>
              {forceWrap(row["REMARKS"])}
            </Text>
          </View>
      )
    }

    return (
      <>
          {!isDualPDF ? (
         <>
         <View style={{ marginBottom: '50px' }}>
          {tableData.slice(0,26).map((x:any,index:number) => tableRender(x,index))}
         </View>
          {tableData.slice(26).map((x:any,index:number) => tableRender(x,index))}
         </>
        ) : null}



        {/* First 10 rows */}
        {isDualPDF && firstTen.map((row: any, index: number) => (
          tableRender(row,index)
        ))}

        {/* Separator or next-page section */}
        {isDualPDF && remaining.length > 0 && (
          <>
            {isDualPDF ? balaSign('',false,'dcp') : null}
            {remaining.map((row: any, index: number) => (
              tableRender(row,index)
            ))}
          </>
        )}
      </>
    );

  } catch (err) {
    console.error("Failed to parse DynamicTable elementValue", err);
    return null;
  }
})()}

{/* Final Remarks and Signature Section */}
{/* Final Remarks and Signature Section (without background color) */}
<View style={styles.row}>
  <Text style={[styles.plainCellLabel,{textAlign:"center"}]}>{masteringStore.DcpEncrypedOpenReportInfo[18]?.elementName}:</Text>
  <Text style={[styles.cell1,{textAlign:"center"}]}>{masteringStore.DcpEncrypedOpenReportInfo[18]?.elementValue}</Text>
  <Text style={[styles.plainCellLabel, {textAlign:"center"}]}>{masteringStore.DcpEncrypedOpenReportInfo[20]?.elementName}</Text>
  <Text style={[styles.cell, styles.noRightBorder,{textAlign:"center"}]}>{masteringStore.DcpEncrypedOpenReportInfo[20]?.elementValue}</Text>
</View>

<View style={[styles.row, { minHeight: 50 }]}>
    <View style={[styles.plainCellLabel, { justifyContent: 'center', textAlign:"center" }]}>
    <Text>{masteringStore.DcpEncrypedOpenReportInfo[21]?.elementName}</Text>
  </View>
  <View style={[styles.cell1, { flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }]}>
  <Image
    src={
      masteringStore.DcpEncrypedOpenReportInfo[18]?.elementValue?.toLowerCase()?.includes('riaz khan') 
      ? getImageSrc('riaz khan') 
      : masteringStore.DcpEncrypedOpenReportInfo[18]?.elementValue?.toLowerCase()?.includes('siddharth') 
      ? getImageSrc('siddharth')
      : masteringStore.DcpEncrypedOpenReportInfo[18]?.elementValue?.toLowerCase()?.includes('kalai') 
      ? getImageSrc('kalai')
      : masteringStore.DcpEncrypedOpenReportInfo[18]?.elementValue?.toLowerCase()?.replaceAll(' ','')?.includes('arulkumar')
      ? getImageSrc('arulkumar')
      : masteringStore.DcpEncrypedOpenReportInfo[18]?.elementValue?.toLowerCase()?.includes('karthick') 
      ? getImageSrc('karthick')
      : "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAEklEQVR42mP8z8BQDwAF/gJ+W6Cn5QAAAABJRU5ErkJggg=="
    }
    style={{ width: 120, height: 30 }}
  />
</View>

   <View style={[styles.plainCellLabel, { justifyContent: 'center', textAlign:'center' }]}>
    <Text>{masteringStore.DcpEncrypedOpenReportInfo[21]?.elementName}</Text>
  </View>
  <View style={[styles.cell,styles.noRightBorder, { flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }]}>
  <Image
    src={
      masteringStore.DcpEncrypedOpenReportInfo[20]?.elementValue?.toLowerCase()?.includes('riaz khan') 
      ? getImageSrc('riaz khan') 
      : masteringStore.DcpEncrypedOpenReportInfo[20]?.elementValue?.toLowerCase()?.includes('siddharth') 
      ? getImageSrc('siddharth')
      : masteringStore.DcpEncrypedOpenReportInfo[20]?.elementValue?.toLowerCase()?.includes('kalai') 
      ? getImageSrc('kalai')
      : masteringStore.DcpEncrypedOpenReportInfo[20]?.elementValue?.toLowerCase()?.replaceAll(' ','')?.includes('arulkumar')
      ? getImageSrc('arulkumar')
      : masteringStore.DcpEncrypedOpenReportInfo[20]?.elementValue?.toLowerCase()?.includes('karthick') 
      ? getImageSrc('karthick')
      : "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAEklEQVR42mP8z8BQDwAF/gJ+W6Cn5QAAAABJRU5ErkJggg=="
    }    
    style={{ width: 80, height: 30 }}
  />
</View>
</View>

<View style={styles.row}>
  <Text style={[styles.plainCellLabel,{textAlign:"center"}]}>{masteringStore.DcpEncrypedOpenReportInfo[19]?.elementName}:</Text>
  <Text style={[styles.cell1,{textAlign:"center"}]}>{masteringStore.DcpEncrypedOpenReportInfo[19]?.elementValue}</Text>
  <Text style={[styles.plainCellLabel, {textAlign:"center"}]}>{masteringStore.DcpEncrypedOpenReportInfo[19]?.elementName}</Text>
  <Text style={[styles.cell, styles.noRightBorder,{textAlign:"center"}]}>{masteringStore.DcpEncrypedOpenReportInfo[19]?.elementValue}</Text>
</View>

<View style={styles.row}>
  <Text style={{padding:4}}>
  <Text style={{ fontWeight: 'bold', fontSize: '6.5px' }}>{masteringStore.DcpEncrypedOpenReportInfo[14]?.elementName}</Text>
  <Text  style={{ fontSize: '6.5px', marginLeft:"5px" }}>:{masteringStore.DcpEncrypedOpenReportInfo[14]?.elementValue}</Text>
</Text>
</View>

<View style={[styles.row, { minHeight: 50 }]}>
  <Text style={{padding:4}}>
  <Text style={{ fontWeight: 'bold', fontSize: '6.5px' }}>{masteringStore.DcpEncrypedOpenReportInfo[15]?.elementName}</Text>
  <Text  style={{ fontSize: '6.5px', marginLeft:"5px" }}>:{masteringStore.DcpEncrypedOpenReportInfo[15]?.elementValue}</Text>
</Text>
</View>

<View style={[styles.row, { minHeight: 40 }]}>
<View style={[styles.cell2]}>
  <Image
    src={ masteringStore.DcpEncrypedOpenReportInfo[16]?.elementValue?.toLowerCase()?.includes('pramod')
        ? getImageSrc('pramod')
        : masteringStore.DcpEncrypedOpenReportInfo[16]?.elementValue?.toLowerCase()?.includes('rajan')
        ? getImageSrc('rajan')
        : 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAEklEQVR42mP8z8BQDwAF/gJ+W6Cn5QAAAABJRU5ErkJggg=='
    }
    style={{ width: 60, height: 30, marginBottom: 5 }}
  />
  <Text>
  <Text style={{ fontWeight: 'bold' }}>{masteringStore.DcpEncrypedOpenReportInfo[16]?.elementName}</Text>
  <Text>: Approved by {masteringStore.DcpEncrypedOpenReportInfo[16]?.elementValue}</Text>
</Text>
 
</View>
<View style={[styles.cell1,styles.noRightBorder, {justifyContent:"flex-end"}]}>
  <Text>
  <Text style={{ fontWeight: 'bold' }}>{masteringStore.DcpEncrypedOpenReportInfo[17]?.elementName}</Text>
  <Text>:{masteringStore.DcpEncrypedOpenReportInfo[17]?.elementValue}</Text>
</Text>
</View>
</View>
{isDualPDF ? balaSign('10',false) : null}
 </Page>
  </Document>
);
}
export default DCPEncryptedOpenReport;
